class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.mainMenu = this.querySelector('.menu-left');
        this.mainMenuLinks = document.querySelectorAll(
            '.mainMenu > ul > li > a'
        );
        this.submenus = document.querySelectorAll('.submenu');
        this.searchButton = this.querySelector('.searchButton');
        this.cartButton = document.querySelector('#cart-item-count');
        this.mobileCartButton = document.querySelector('.mobileHeader .left');
        this.mobileMenuOpener = document.querySelector('.mobileMenuOpener');

        this.onScrollHandler = this.onScroll.bind(this);
        this.onShowSubmenuHandler = this.showSubmenu.bind(this);
        this.onHideSubmenusHandler = this.hideSubmenus.bind(this);
        this.onMobileMenuHandler = this.onMobileMenu.bind(this);
        this.onCartHandler = this.onCart.bind(this);

        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.mainMenu.addEventListener(
            'mouseleave',
            this.onHideSubmenusHandler
        );
        this.searchButton.addEventListener('click', this.onSearch);
        this.cartButton.addEventListener('click', this.onCart);
        this.mobileCartButton.addEventListener('click', this.onCartHandler);
        this.mobileMenuOpener.addEventListener(
            'click',
            this.onMobileMenuHandler
        );

        let scope = this;

        if (isTouchDevice()) {
            this.mainMenuLinks.forEach((link) => {
                link.addEventListener('click', scope.onShowSubmenuHandler);
            });
        } else {
            this.mainMenuLinks.forEach((link) => {
                link.addEventListener('mouseenter', scope.onShowSubmenuHandler);
            });
        }

        this.createObserver();
    }

    disconnectedCallback() {
        this.removeEventListener(
            'preventHeaderReveal',
            this.hideHeaderOnScrollUp
        );
        window.removeEventListener('scroll', this.onScrollHandler);

        let scope = this;
        if (isTouchDevice()) {
            this.mainMenuLinks.forEach((link) => {
                link.removeEventListener('click', scope.onShowSubmenuHandler);
            });
        } else {
            this.mainMenuLinks.forEach((link) => {
                link.removeEventListener(
                    'mouseenter',
                    scope.onShowSubmenuHandler
                );
            });
        }

        this.mainMenu.removeEventListener(
            'mouseleave',
            this.onHideSubmenusHandler
        );
        this.searchButton.removeEventListener('click', this.onSearch);
        this.cartButton.removeEventListener('click', this.onCart);
        this.mobileCartButton.removeEventListener('click', this.onCart);
        this.mobileMenuOpener.removeEventListener(
            'click',
            this.onMobileMenuHandler
        );
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

        if (
            scrollTop > this.currentScrollTop &&
            scrollTop > this.headerBounds.bottom
        ) {
            requestAnimationFrame(this.hide.bind(this));
        } else if (
            scrollTop < this.currentScrollTop &&
            scrollTop > this.headerBounds.bottom
        ) {
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        document.body.classList.add(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky'
        );
        this.closeMenuDisclosure();
    }

    reveal() {
        document.body.classList.add('shopify-section-header-sticky', 'animate');
        document.body.classList.remove('shopify-section-header-hidden');
    }

    reset() {
        document.body.classList.remove(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky',
            'animate'
        );
    }

    closeMenuDisclosure() {
        this.disclosures =
            this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
    }

    showSubmenu(e) {
        e.preventDefault();
        e.stopPropagation();

        this.hideSubmenus();
        this.mainMenuLinks.forEach((link) => {
            link.classList.add('unselected');
            link.classList.remove('current');
        });

        let link = e.target;
        let parent = link.closest('li');
        let currentSubmenu = parent.querySelector('.submenu');

        link.classList.remove('unselected');
        link.classList.add('current');

        let headerHeight = document.querySelector('sticky-header').offsetHeight;

        if (currentSubmenu) {
            let height = headerHeight + currentSubmenu.offsetHeight - 20;
            document.querySelector('#blurFilter').style.height = height + 'px';
        } else {
            document.querySelector('#blurFilter').style.height =
                headerHeight + 'px';
        }

        let currents = document.querySelectorAll('.submenu');
        if (currentSubmenu) {
            if (isTouchDevice()) {
                e.target.href = 'javascript:';
            }
            currents.forEach((current) => {
                current.classList.remove('show');
            });

            currentSubmenu.classList.add('show');
        } else {
            if (isTouchDevice()) {
                window.location = e.target.href;
            }
        }

        document.body.classList.add('menu-opened');
        document.body.classList.remove('search-opened');
        if (isTouchDevice()) {
            return false;
        }
    }

    hideSubmenus() {
        this.mainMenuLinks.forEach((link) => {
            link.classList.remove('unselected');
        });

        this.submenus.forEach((submenu) => {
            submenu.classList.remove('show');
        });

        document.body.classList.remove('menu-opened');
    }

    onSearch() {
        document.body.classList.toggle('search-opened');
        document.body.classList.remove('cart-opened');

        document.querySelector('.searchForm form').reset();
        document.querySelector('.searchForm input[name="q"]').value = '';

        if (document.body.classList.contains('search-opened')) {
            document.querySelector('.searchForm input[name="q"]').focus();
            document.querySelector('#blurFilter').style.height = '100%';
        }
    }

    onCart() {
        let miniCart = document.querySelector('cart-mini');
        if (miniCart) {
            miniCart.show();
        }
    }

    onMobileMenu() {
        document.body.classList.toggle('menu-opened');
        document.body.classList.remove('cart-opened');

        if (document.body.classList.contains('menu-opened')) {
            this.mobileMenuOpener.innerHTML = 'Close';
        } else {
            this.mobileMenuOpener.innerHTML = 'Menu';
        }
    }
}

customElements.define('sticky-header', StickyHeader);

function setupMobileCurrentMenu() {
    let currentPage = '';

    let mobileMenu = document.querySelector('.mobileMenu');
    let mainMobileMenu = mobileMenu.querySelectorAll('.mainMenu > ul > li > a');

    let bodyClassList = document.body.classList;
    if (
        bodyClassList.contains('about') ||
        bodyClassList.contains('explore') ||
        bodyClassList.contains('contact')
    ) {
        currentPage = 'more';
    }

    let collectionWoman = document.body.classList.contains(
        'main-collection-woman'
    );
    let collectionMan = document.body.classList.contains('main-collection-man');

    if (collectionWoman) {
        currentPage = 'woman';
    }

    if (collectionMan) {
        currentPage = 'man';
    }

    let collection = document.body.classList.contains('collection');
    if (collection) {
        let breadCrumb = document.querySelector('.breadcrumb a');
        if (breadCrumb) {
            if (breadCrumb.innerHTML == 'Woman') {
                currentPage = 'woman';
            }
            if (breadCrumb.innerHTML == 'Man') {
                currentPage = 'man';
            }
        } else {
            currentPage = 'market';
        }
    }

    let product = document.body.classList.contains('product');
    if (product) {
        let sizeGuideWoman = document.querySelector('.sizeGuideMenu.woman');
        let sizeGuideMan = document.querySelector('.sizeGuideMenu.man');

        if (sizeGuideWoman) {
            currentPage = 'woman';
        } else if (sizeGuideMan) {
            currentPage = 'man';
        } else {
            currentPage = 'market';
        }
    }

    if (currentPage != '') {
        mainMobileMenu.forEach((link) => {
            link.classList.add('unselected');
        });

        let currentMenu = mobileMenu.querySelector(
            '.mainMenu > ul > li > a.' + currentPage
        );
        if (currentMenu) {
            currentMenu.classList.add('current');
            currentMenu.classList.remove('unselected');


            if (document.querySelector('.mobileMenu .submenu.' + currentPage)) {

                document
                    .querySelector('.mobileMenu .submenu.' + currentPage)
                    .classList.add('show');
            }
        }
    }
}

if (isTouchDevice()) {
    setupMobileCurrentMenu();
}
